/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BatchInternalAndConnectNextContactsDateDto } from '../models/BatchInternalAndConnectNextContactsDateDto';
import type { CustomerData } from '../models/CustomerData';
import type { EmailResult } from '../models/EmailResult';
import type { EmailTaskEnum } from '../models/EmailTaskEnum';
import type { InitContactDialogInput } from '../models/InitContactDialogInput';
import type { NextContactDTO } from '../models/NextContactDTO';
import type { PhoneLogResult } from '../models/PhoneLogResult';
import type { SmsResult } from '../models/SmsResult';
import type { SmsTaskEnum } from '../models/SmsTaskEnum';
import type { UpdateNextContactInput } from '../models/UpdateNextContactInput';
import type { UpdateResposibleUserInput } from '../models/UpdateResposibleUserInput';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ContactsService {

  /**
   * @param contactId 
   * @returns any Success
   * @throws ApiError
   */
  public static postAddFeedbackUpdateToHistory(
contactId?: number,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/AddFeedbackUpdateToHistory',
      query: {
        'contactId': contactId,
      },
    });
  }

  /**
   * @param id 
   * @param customerName 
   * @param email 
   * @param phone 
   * @param postcode 
   * @returns CustomerData Success
   * @throws ApiError
   */
  public static getContactsLookUp(
id?: number,
customerName?: string,
email?: string,
phone?: string,
postcode?: string,
): CancelablePromise<Array<CustomerData>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Contacts/look-up',
      query: {
        'Id': id,
        'CustomerName': customerName,
        'Email': email,
        'Phone': phone,
        'Postcode': postcode,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns number Success
   * @throws ApiError
   */
  public static postContactsInitContactDialog(
requestBody?: InitContactDialogInput,
): CancelablePromise<number> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Contacts/init-contact-dialog',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param requestBody 
   * @returns boolean Success
   * @throws ApiError
   */
  public static postContactsCheckExistContactDialog(
requestBody?: InitContactDialogInput,
): CancelablePromise<boolean> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Contacts/check-exist-contact-dialog',
      body: requestBody,
      mediaType: 'application/json-patch+json',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param dialogId 
   * @param formData 
   * @returns any Success
   * @throws ApiError
   */
  public static postContactsContactDialogsEmail(
dialogId: number,
formData?: {
Subject: string;
Body: string;
Attachments?: Array<Blob>;
},
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/Contacts/contact-dialogs/{dialogId}/email',
      path: {
        'dialogId': dialogId,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param userCodes 
   * @param ids 
   * @param from 
   * @param to 
   * @param enquiry 
   * @param enquiryCrm 
   * @returns NextContactDTO Success
   * @throws ApiError
   */
  public static getContactsNextContacts(
userCodes?: Array<string>,
ids?: Array<number>,
from?: string,
to?: string,
enquiry?: Array<number>,
enquiryCrm?: Array<number>,
): CancelablePromise<Array<NextContactDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Contacts/next-contacts',
      query: {
        'userCodes': userCodes,
        'ids': ids,
        'from': from,
        'to': to,
        'enquiry': enquiry,
        'enquiryCrm': enquiryCrm,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param enquiryCrmIds 
   * @param enquiryIds 
   * @param leadIds 
   * @returns BatchInternalAndConnectNextContactsDateDto Success
   * @throws ApiError
   */
  public static getContactsBatchInternalAndConnectNextContacts(
enquiryCrmIds?: Array<number>,
enquiryIds?: Array<number>,
leadIds?: Array<number>,
): CancelablePromise<Array<BatchInternalAndConnectNextContactsDateDto>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Contacts/batch-internal-and-connect-next-contacts',
      query: {
        'enquiryCrmIds': enquiryCrmIds,
        'enquiryIds': enquiryIds,
        'leadIds': leadIds,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param enquiryCrmId 
   * @param leadId 
   * @returns NextContactDTO Success
   * @throws ApiError
   */
  public static getContactsConnectNextMessage(
enquiryCrmId?: number,
leadId?: number,
): CancelablePromise<Array<NextContactDTO>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Contacts/connect-next-message',
      query: {
        'EnquiryCrmId': enquiryCrmId,
        'LeadId': leadId,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putContactsNextContacts(
id: number,
requestBody?: UpdateNextContactInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Contacts/next-contacts/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param id 
   * @param requestBody 
   * @returns any Success
   * @throws ApiError
   */
  public static putContactsNextContactsResponsibleUser(
id: number,
requestBody?: UpdateResposibleUserInput,
): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/Contacts/next-contacts/{id}/responsible-user',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json-patch+json',
    });
  }

  /**
   * @param entityType
 *
 * 0 = Unknown
 *
 * 1 = Lead
 *
 * 2 = Pss
 *
 * 3 = SvcEval
 *
 * 4 = SvcProsp
 *
 * 5 = SendManagerAppraisalLinkToCustomer
 *
 * 6 = SendAppointmentConfirmation
 *
 * 7 = SendHandoverConfirmation
 *
 * 8 = WebClientUserSendTo
 *
 * 9 = WebClientUserReceivedTo
 *
 * 10 = DealSendOffer
 *
 * 11 = AutomotiveEnquirySendDDI
 *
 * 12 = CheckInNotification
 *
 * 13 = VipPhonecall
 *
 * 99 = Free
 *
 * 100 = ServiceBooking
 *
 * 101 = SalesOffer
 *
 * 103 = PartRequest
 *
 * 104 = PartRequestFrom
 *
 * 105 = PartsDiscrepancies
 *
 * 106 = EnquiryCrm
 *
 * 107 = Appraisal
 *
 * 108 = EDocument
 *
 * 109 = HandoverFollowUp
 *
 * 110 = PurchaseOrderLog
 *
 * 111 = Reservation
 *
 * 112 = PaymentRequest
 *
 * 113 = ServicePlanQuote
 *
 * 114 = Sorder
 *
 * 115 = AuctionCarLog
 *
 * 116 = InternalDialog
 *
 * 117 = UserCandidateDetails
 *
 * 119 = SoHeaderSend
 *
 * 120 = SoHeaderReceived
 *
 * 121 = ServicePlanEmails
 *
 * 123 = WebclientAppraisal
 *
 * 124 = All
   * @param entityUid 
   * @returns EmailResult Success
   * @throws ApiError
   */
  public static getContactsEmails(
entityType: EmailTaskEnum,
entityUid: string,
): CancelablePromise<Array<EmailResult>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Contacts/emails',
      query: {
        'entityType': entityType,
        'entityUid': entityUid,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param entityType
 *
 * 2 = ReceivedFrom
 *
 * 3 = LeadSendTo
 *
 * 4 = LeadReceivedFrom
 *
 * 5 = SvcEvalSendTo
 *
 * 6 = VipPhonecall
 *
 * 19 = EnquiryCrm
 *
 * 21 = HandoverFollowUp
 *
 * 22 = Sorder
 *
 * 25 = SoHeader
   * @param entityUid 
   * @returns SmsResult Success
   * @throws ApiError
   */
  public static getContactsSms(
entityType: SmsTaskEnum,
entityUid: string,
): CancelablePromise<Array<SmsResult>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Contacts/sms',
      query: {
        'entityType': entityType,
        'entityUid': entityUid,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

  /**
   * @param phone 
   * @returns PhoneLogResult Success
   * @throws ApiError
   */
  public static getContactsPhonelog(
phone: string,
): CancelablePromise<Array<PhoneLogResult>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/Contacts/phonelog',
      query: {
        'phone': phone,
      },
      errors: {
        400: `Bad Request`,
        500: `Server Error`,
      },
    });
  }

}
